import {Component, Fragment, h} from "preact";
import DropdownSelector from "../../_common/components/dropdownSelector/dropdownSelector";


export default function AcademicProgramSelector ({academicProgramSelector, fullWidth, onChange, selected}){

    return (

        <Fragment>
            {academicProgramSelector.length > 1
            ? <AcademicProgramMulti
                    academicProgramSelector={academicProgramSelector}
                    fullWidth={fullWidth}
                    onChange={onChange}
                    selected={selected}
                />
            : <div className='font-16'>{academicProgramSelector[0]?.name || academicProgramSelector[0]?.title}</div>
            }
        </Fragment>
    )
}

const AcademicProgramMulti = ({academicProgramSelector, fullWidth, onChange, selected}) => (
    <Fragment>
        <DropdownSelector
            values={academicProgramSelector}
            onChange={onChange}
            fullWidth={fullWidth}
            iconDropdownVisible={<i className='far fa-chevron-up'/>}
            iconDropdownHidden={<i className='far fa-chevron-down'/>}
            selected={selected}
        />
    </Fragment>
);
